<template>
  <v-sheet width="250px">
    <div class="text-caption font-weight-regular">Ordenar por:</div>
    <v-select
      v-model="model"
      :items="order"
      :clearable="model !== 'codigo-desc'"
      dense
    />
  </v-sheet>
</template>

<script>
import { setCookie, getCookie } from "../../../utils/cookie";

const _data = {
  model: null,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    order() {
      const order = [
        {
          text: "Últimos cadastrados",
          value: "codigo-desc",
        },
        {
          text: "Preço crescente",
          value: "preco-asc",
        },
        {
          text: "Preço decrescente",
          value: "preco-desc",
        },
      ];

      if (!["/rural", "/terrenos"].includes(this.$route.path)) {
        order.push(
          {
            text: "Nº de Quartos crescente",
            value: "quarto-asc",
          },
          {
            text: "Nº de Quartos decrescente",
            value: "quarto-desc",
          },
          {
            text: "Nº de Suítes crescente",
            value: "suite-asc",
          },
          {
            text: "Nº de Suítes decrescente",
            value: "suite-desc",
          },
          {
            text: "Área Construída crescente",
            value: "area-construida-asc",
          },
          {
            text: "Área Construída decrescente",
            value: "area-construida-desc",
          }
        );
      }

      order.push(
        {
          text: "Área Total crescente",
          value: "area-total-asc",
        },
        {
          text: "Área Total decrescente",
          value: "area-total-desc",
        }
      );

      return order;
    },
  },
  methods: {
    setCookie,
    getCookie,
  },
  watch: {
    model(v) {
      if (v) {
        const orderCookie = this.getCookie("ordenar");

        if (v !== orderCookie) {
          this.setCookie("ordenar", v, 365);

          this.$emit("reorder");
        }
      } else {
        this.model = "codigo-desc";
      }
    },
  },
  mounted() {
    const orderCookie = this.getCookie("ordenar");

    this.model = orderCookie ? orderCookie : "codigo-desc";

    if (!orderCookie) this.setCookie("ordenar", "codigo-desc", 365);
  },
};
</script>
